import DispatchConstants from 'app/shared/constants/DispatchConstants';
import PaidInclusionDetails from 'app/shared/model/PaidInclusionDetails';

const initState = () => (PaidInclusionDetails({}));

const reducer = (state = initState(), action) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.PAID_INCLUSION_DETAILS_SUCCESS:
            return {
                ...state,
                ...payload,
            };
        case DispatchConstants.PAID_INCLUSION_DETAILS_FAIL:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};

export default reducer;
